module.exports = __webpack_public_path__ + "img/流体力学4_1_2.c4809504.jpg";